import * as Yup from 'yup';

import createEmployeFormModel from './createEmployeFormModel';

const {

  formField: {

    // DATOS CLIENTE 
    document_type,
    document_number,
    expedition_place,
    name,
    last_name,
    date_of_birth,
    gender,
    civil_status,
    landline,
    cell_phone,
    whatsapp,
    rh,
    dominance,
    allergies,
    cedula,
    cv,
    housing_type,
    neighborhood,
    stratum,
    cost_center,
    compani,
    work_headquarters,
    cargo,
    scholarship,
    institution,
    degree,
    address,
    email,


    // LABORAL 
    type_contract,
    salary_base,
    payment_method,
    frecuency_payment,
    associated_bank,
    certificate_bank,
    account_number,
    date_start_contract,
    vacation_acumulate,
    bonification_aditional,
    dayrest,


    // SEGURIDAD SOCIAL 
    eps,
    familyCompensation,
    fileCajaCompensacion,
    cesantias,
    fileCesantias,
    pension,
    fileArl,
    // DOTACION 
    // items,


  }

} = createEmployeFormModel;


export default [

  

  // INFORMACION BASICA 
  Yup.object().shape({ 
    [document_type.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined) // 👈 
    .required(`${document_type.requiredErrorMsg}`),
    [name.name]: Yup.string().required(`${name.requiredErrorMsg}`),    
    [document_number.name]: Yup.number().typeError('El numero documento debe ser numerico').label(`${document_number.typeDataMsg}`).required(`${document_number.requiredErrorMsg}`),
    [last_name.name]: Yup.string().required(`${last_name.requiredErrorMsg}`),
    [date_of_birth.name]: Yup.string().required(`${date_of_birth.requiredErrorMsg}`),
    [expedition_place.name]: Yup.string().required(`${expedition_place.requiredErrorMsg}`),
    [gender.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined) // 👈 
    .required(`${gender.requiredErrorMsg}`),
    [civil_status.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined) // 👈
    .required(`${civil_status.requiredErrorMsg}`),
    [landline.name]: Yup.string().nullable(),
    [cell_phone.name]: Yup.string().required(`${cell_phone.requiredErrorMsg}`),
    [whatsapp.name]: Yup.boolean(),
    [rh.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined) // 👈 
    .required(`${rh.requiredErrorMsg}`),
    [dominance.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined) // 👈
    .required(`${dominance.requiredErrorMsg}`),
    [allergies.name]: Yup.string().nullable(), 
    [cedula.name]: Yup.string().required(`${cedula.requiredErrorMsg}`),
    [housing_type.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined) // 👈 
    .required(`${housing_type.requiredErrorMsg}`), 
    [cv.name]: Yup.string().required(`${cv.requiredErrorMsg}`),
    // [cv.name]: Yup.object().shape({
    //   value: Yup.string().required(),
    //   label: Yup.string().required()
    // }).default(undefined) // 👈 
    // .required(`${cv.requiredErrorMsg}`),
    [address.name]: Yup.string().required(`${address.requiredErrorMsg}`),
    [neighborhood.name]: Yup.string().required(`${neighborhood.requiredErrorMsg}`),
    [stratum.name]: Yup.string().required(`${stratum.requiredErrorMsg}`),
    [cost_center.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined) // 👈 
    .required(`${cost_center.requiredErrorMsg}`),
    [compani.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined) // 👈 
    .required(`${compani.requiredErrorMsg}`),
    [work_headquarters.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined) // 👈 
    .required(`${work_headquarters.requiredErrorMsg}`),
    [cargo.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined) // 👈 
    .required(`${cargo.requiredErrorMsg}`),
    [scholarship.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined) // 👈 
    .required(`${scholarship.requiredErrorMsg}`),
    [institution.name]: Yup.string().required(`${institution.requiredErrorMsg}`),
    [degree.name]: Yup.string().required(`${degree.requiredErrorMsg}`),
    [email.name]: Yup.string().required(`${email.requiredErrorMsg}`).email(`${email.requiredErrorMsg}`)
    
  }),

 
  // LABORAL 
  Yup.object().shape({

    [type_contract.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined) // 👈 
    .required(`${type_contract.requiredErrorMsg}`),
    [payment_method.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined) // 👈 
    .required(`${payment_method.requiredErrorMsg}`),
    [frecuency_payment.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined) // 👈 
    .required(`${frecuency_payment.requiredErrorMsg}`),
    
    // REVISAR ERA document_number
    [document_number.name]: Yup.number().typeError('El numero documento debe ser numerico').label(`${document_number.typeDataMsg}`).required(`${document_number.requiredErrorMsg}`),
    [associated_bank.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined) // 👈 
    .required(`${associated_bank.requiredErrorMsg}`),
    [certificate_bank.name]: Yup.string().required(`${certificate_bank.requiredErrorMsg}`),
    [account_number.name]: Yup.string().required(`${account_number.requiredErrorMsg}`),
    [vacation_acumulate.name]: Yup.number().typeError('El numero documento debe ser numerico').label(`${vacation_acumulate.typeDataMsg}`).required(`${vacation_acumulate.requiredErrorMsg}`),
    [bonification_aditional.name]: Yup.number().typeError('El numero documento debe ser numerico').label(`${bonification_aditional.typeDataMsg}`).required(`${bonification_aditional.requiredErrorMsg}`),
    [date_start_contract.name]: Yup.string().required(`${date_start_contract.requiredErrorMsg}`),
    [salary_base.name]: Yup.number().typeError('El numero documento debe ser numerico').label(`${salary_base.typeDataMsg}`).required(`${salary_base.requiredErrorMsg}`),
    // [dayrest.name]: Yup.string().required(`${dayrest.requiredErrorMsg}`),

    
   }),



   // SEGURIDAD SOCIAL 
  Yup.object().shape({

    [eps.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined) // 👈 
    .required(`${eps.requiredErrorMsg}`),
    [familyCompensation.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined) // 👈 
    .required(`${familyCompensation.requiredErrorMsg}`),
    [fileCajaCompensacion.name]: Yup.string().required(`${fileCajaCompensacion.requiredErrorMsg}`),
    [cesantias.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined) // 👈 
    .required(`${cesantias.requiredErrorMsg}`),
    [fileCesantias.name]: Yup.string().required(`${fileCesantias.requiredErrorMsg}`),
    [pension.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined) // 👈 
    .required(`${pension.requiredErrorMsg}`),
    [fileArl.name]: Yup.string().required(`${fileArl.requiredErrorMsg}`),
  }),


  // DOTACION  
  Yup.object().shape({

    // [items.name]: Yup.object().shape({
    //   value: Yup.string().required(),
    //   label: Yup.string().required()
    // }).default(undefined) // 👈 
    // .required(`${items.requiredErrorMsg}`),


  })
   
  
];   

